import { PendingOrder } from '@infrab4a/connect';
import { SendFailure } from 'src/app/admin-api';

export const STORE_ACTIVATION_BOT_NAME = 'Robô de Loja Ativação';

export type FailExportRow = SendFailure & {
  orderId?: string;
  orderNumber?: string;
};

function firstErrorMessage(errorMessage: unknown): string | null {
  if (!Array.isArray(errorMessage) || errorMessage.length === 0) {
    return null;
  }

  const first = errorMessage[0];
  if (typeof first !== 'string') {
    return null;
  }

  const trimmed = first.trim();
  return trimmed ? trimmed : null;
}

/**
 * Maps PendingOrder docs (Firestore collection `transId`) to fail-export rows.
 * Keeps only documents whose `errorMessage[0]` is a non-empty string.
 */
export function mapPendingOrdersToFailExports(
  orders: PendingOrder[] | null | undefined
): FailExportRow[] {
  if (!orders?.length) {
    return [];
  }

  const failures: FailExportRow[] = [];

  for (const order of orders) {
    const payloadError = firstErrorMessage(order.errorMessage);
    if (payloadError === null) {
      continue;
    }

    failures.push({
      descriptionBot: STORE_ACTIVATION_BOT_NAME,
      payloadError,
      step: order.id,
      orderId: order.id
    });
  }

  return failures;
}
